"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var composition_api_1 = require("@vue/composition-api");
exports.default = composition_api_1.defineComponent({
    props: {
        name: { type: String, required: true },
        value: { type: Boolean, default: false },
        label: { type: String, default: '' },
        error: { type: Object },
    },
    setup: function (props, context) {
        var id = props.name;
        var wrapperClasses = composition_api_1.computed(function () {
            return {
                'wok--form-item': true
            };
        });
        var inputClasses = composition_api_1.computed(function () {
            return {
                '': true
            };
        });
        var onChange = function (evt) {
            if (evt.target instanceof HTMLInputElement) {
                context.emit('input', evt.target.checked);
            }
        };
        return {
            id: id,
            wrapperClasses: wrapperClasses,
            inputClasses: inputClasses,
            onChange: onChange
        };
    }
});
